export let AuthenticateGrantType;

(function (AuthenticateGrantType) {
  AuthenticateGrantType["Password"] = "password";
  AuthenticateGrantType["Assertion"] = "assertion";
})(AuthenticateGrantType || (AuthenticateGrantType = {}));

export let AuthenticationScope;

(function (AuthenticationScope) {
  AuthenticationScope["PublicUser"] = "public user";
  AuthenticationScope["PublicUserAdmin"] = "public user admin";
})(AuthenticationScope || (AuthenticationScope = {}));

export let AuthenticationTokenType;

(function (AuthenticationTokenType) {
  AuthenticationTokenType["Bearer"] = "bearer";
})(AuthenticationTokenType || (AuthenticationTokenType = {}));

export let AuthenticateProvider;

(function (AuthenticateProvider) {
  AuthenticateProvider["Facebook"] = "facebook";
  AuthenticateProvider["Google"] = "google";
  AuthenticateProvider["Apple"] = "apple";
  AuthenticateProvider["CrossPortal"] = "cross_portal";
})(AuthenticateProvider || (AuthenticateProvider = {}));

export let FacebookLoginStatus;

(function (FacebookLoginStatus) {
  FacebookLoginStatus["Connected"] = "connected";
})(FacebookLoginStatus || (FacebookLoginStatus = {}));

export let AppleIDLoginStatus;

(function (AppleIDLoginStatus) {
  AppleIDLoginStatus["Success"] = "AppleIDSignInOnSuccess";
  AppleIDLoginStatus["Failure"] = "AppleIDSignInOnFailure";
})(AppleIDLoginStatus || (AppleIDLoginStatus = {}));

export const FACEBOOK_PERMISSIONS = 'email';